import { map, withLatestFrom } from 'rxjs/operators';
import { replace } from '@lagunovsky/redux-react-router';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { locationSelector } from '../_selectors/location.selector';
import { RouterAction } from '../router.action';

type IState =
  & IGetSelectorStateType<typeof locationSelector>;

export const clearLocationSateEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(RouterAction.clearLocationState),
  withLatestFrom(state$),
  map(([, state]) => {
    const location = locationSelector(state);

    return replace({
      ...location,
    }, undefined);
  }),
);
